var React = require('react');

function Dot (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"15","cy":"15","r":"13","fill":"white","stroke":"black","strokeWidth":"4"}));
}

Dot.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Dot;

Dot.default = Dot;
